const convertRuToEn = input => {
	if (!input) return

	const ru = "ёйцукенгшщзхъфывапролджэячсмитьбю.";
	const en = "`qwertyuiop[]asdfghjkl;'zxcvbnm,/.";

	return input
		.split("")
		.map(char => {
			const index = ru.indexOf(char.toLowerCase());
			if (index === -1) return char;

			const newChar = en[index];
			return char === char.toUpperCase()
				? newChar.toUpperCase()
				: newChar;
		})
		.join("");
};

const formatNumberWithSpaces = (number, symbol = " ") => {
	if (typeof number === "string") {
		number = number.replace(/[a-zA-Z]/g, "");
	}
	if (!number || isNaN(number)) {
		return "";
	}
	number = Number(number);
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, symbol);
}

export { formatNumberWithSpaces, convertRuToEn };
